import GetPremiumForm from './GetPremiumForm'
export default GetPremiumForm